"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertGuestsAndSubject = void 0;
const actions_1 = require("@/wrapper/actions");
async function InsertGuestsAndSubject(payload, dialogRef) {
    const { guests, subject } = payload;
    const result = await (0, actions_1.getOutlookRecipients)();
    if (!result || result.error || !result.contacts) {
        console.error('Failed to fetch Outlook recipients:', result?.error || 'Unknown error');
        return;
    }
    const { contacts } = result;
    const isAnyFieldEmpty = Object.values(contacts).some((field) => field.length === 0);
    const [inviteeEmail] = guests;
    if (isAnyFieldEmpty && inviteeEmail?.email) {
        await (0, actions_1.setRecipientsEmails)({ TO: [{ emailAddress: inviteeEmail.email, name: inviteeEmail.name || inviteeEmail.email }] });
    }
    const trimmedSubject = subject?.trim();
    if (trimmedSubject) {
        await (0, actions_1.setSubject)(trimmedSubject);
    }
}
exports.InsertGuestsAndSubject = InsertGuestsAndSubject;
